export default [
  ...applyRules(
    ['guest'],
    [
      {
        path: '',
        redirect: { name: 'login' },
        component: require('@/views/Auth').default,
        children: [
          {
            path: '/login',
            name: 'login',
            component: require('@/components/auth/login/Login').default,
          },
          {
            path: '/recovery',
            component: require('@/components/auth/recovery/RecoveryWrapper')
              .default,
            children: [
              {
                path: 'forgot',
                name: 'forgot',
                component: require('@/components/auth/recovery/password-forgot/PasswordForgot')
                  .default,
              },
              {
                path: 'reset/:email/:token',
                name: 'reset',
                component: require('@/components/auth/recovery/password-reset/PasswordReset')
                  .default,
              },
            ],
          },
          {
            path: '/setup/password',
            name: 'password-setup',
            component: require('@/components/auth/recovery/password-reset/PasswordSetup.vue')
              .default,
          },
        ],
      },
    ],
  ),
  ...applyRules(
    ['auth'],
    [
      {
        path: '',
        component: require('@/views/Dashboard').default,
        children: [
          {
            path: '/profile',
            component: require('@/components/dashboard/profile/ProfileWrapper')
              .default,
            children: [
              {
                path: '',
                name: 'profile.my-profile',
                component: require('@/components/dashboard/profile/UserProfile')
                  .default,
              },
            ],
          },

          { path: '', name: 'index', redirect: { name: 'profile.my-profile' } },

          {
            path: '/chatwoot',
            name: 'chatwoot',
            component: require('@/components/Chatwoot').default,
          },

          ...applyRules(
            ['admins'],
            [
              {
                path: 'a',
                component: require('@/components/dashboard/admin/AdminWrapper')
                  .default,
                children: [
                  // admin routes path is prefixed with /a/
                  /* { path: '', name: 'index', redirect: { name: 'sessions.all.title' } }, */

                  {
                    path: 'sessions',
                    component: require('@/components/dashboard/admin/session/SessionWrapper')
                      .default,
                    children: [
                      {
                        path: 'all',
                        name: 'sessions.all.title',
                        component: require('@/components/dashboard/admin/session/SessionTable')
                          .default,
                      },

                      {
                        path: 'new',
                        name: 'sessions.create.title',
                        component: require('@/components/dashboard/admin/session/SessionForm')
                          .default,
                      },
                      {
                        path: ':id',
                        name: 'sessionDetails',
                        component: require('@/components/dashboard/admin/session/SessionDetailsRemote.vue')
                          .default,
                        props: true,
                      },
                      /* { path: 'completed', name: 'sessions-completed', component: require('@/components/dashboard/admin/session/SessionsCompletedTable').default } */
                    ],
                  },

                  {
                    path: 'users',
                    component: require('@/components/dashboard/admin/user/UserWrapper')
                      .default,
                    children: [
                      {
                        path: 'all',
                        name: 'users.area',
                        component: require('@/components/dashboard/admin/user/UserTable')
                          .default,
                      },
                      {
                        path: 'user-wizard',
                        name: 'users.wizard.title',
                        component: require('@/components/dashboard/admin/user/UserWizard')
                          .default,
                      },
                      {
                        path: 'edit/:id',
                        name: 'profile.edit-profile',
                        component: require('@/components/dashboard/admin/user/UserForm')
                          .default,
                        props: true,
                      },
                    ],
                  },
                  {
                    path: 'families',
                    component: require('@/components/dashboard/admin/family/FamilyWrapper')
                      .default,
                    children: [
                      {
                        path: 'all',
                        name: 'families.all.title',
                        component: require('@/components/dashboard/admin/family/FamilyTable')
                          .default,
                      },
                      {
                        path: 'reports',
                        name: 'families.reports.title',
                        component: require('@/components/dashboard/admin/family/FamilyReportTable')
                          .default,
                      },
                      {
                        path: 'add-balance',
                        name: 'families.add-balance.title',
                        component: require('@/components/dashboard/admin/family/BalanceForm')
                          .default,
                      },
                      {
                        path: 'sub-balance',
                        name: 'families.sub-balance.title',
                        component: require('@/components/dashboard/admin/family/SubBalanceForm')
                          .default,
                      },
                      {
                        path: 'edit/:id',
                        name: 'edit-family',
                        component: require('@/components/dashboard/admin/family/FamilyProfile')
                          .default,
                        props: true,
                      },
                    ],
                  },
                  {
                    path: 'babysitters',
                    component: require('@/components/dashboard/admin/babysitter/BabysitterWrapper')
                      .default,
                    children: [
                      {
                        path: 'all',
                        name: 'babysitters.all.title',
                        component: require('@/components/dashboard/admin/babysitter/BabysitterTable')
                          .default,
                      },
                      {
                        path: 'edit/:id',
                        name: 'edit-babysitter',
                        component: require('@/components/dashboard/admin/babysitter/BabysitterProfile')
                          .default,
                        props: true,
                      },
                      {
                        path: 'documents/:id',
                        name: 'documents',
                        component: require('@/components/dashboard/admin/babysitter/Documents')
                          .default,
                        props: true,
                      },
                      {
                        path: 'add-balance',
                        name: 'add-balance',
                        component: require('@/components/dashboard/admin/babysitter/BabysitterBalanceForm')
                          .default,
                      },
                      {
                        path: 'make-payment',
                        name: 'make-payment',
                        component: require('@/components/dashboard/admin/babysitter/BabysitterPaymentForm')
                          .default,
                      },
                    ],
                  },
                  // {
                  //   path: "notifications",
                  //   component: require("@/components/dashboard/admin/notification/NotificationWrapper")
                  //     .default,
                  //   children: [
                  //     {
                  //       path: "all",
                  //       name: "notifications",
                  //       component: require("@/components/dashboard/admin/notification/NotificationTable")
                  //         .default,
                  //     },
                  //   ],
                  // },
                  {
                    path: 'transactions',
                    component: require('@/components/dashboard/admin/transaction/TransactionWrapper')
                      .default,
                    children: [
                      {
                        path: 'all',
                        name: 'transactions',
                        component: require('@/components/dashboard/admin/transaction/TransactionsTable')
                          .default,
                      },
                      {
                        path: 'accounting',
                        name: 'accounting',
                        component: require('@/components/dashboard/admin/transaction/Accounting')
                          .default,
                      },
                      {
                        path: 'family-overview',
                        name: 'family-overview',
                        component: require('@/components/dashboard/admin/transaction/FamilyOverview')
                          .default,
                      },
                      {
                        path: 'babysitter-overview',
                        name: 'babysitter-overview',
                        component: require('@/components/dashboard/admin/transaction/BabysitterOverview')
                          .default,
                      },
                    ],
                  },
                  {
                    path: 'other',
                    component: require('@/components/dashboard/admin/other/OtherWrapper')
                      .default,
                    children: [
                      {
                        path: 'cities',
                        name: 'cities',
                        component: require('@/components/dashboard/admin/other/Cities')
                          .default,
                      },
                      {
                        path: 'languages',
                        name: 'languages',
                        component: require('@/components/dashboard/admin/other/Languages')
                          .default,
                      },
                      {
                        path: 'nationalities',
                        name: 'nationalities',
                        component: require('@/components/dashboard/admin/other/Nationalities')
                          .default,
                      },
                      {
                        path: 'pets',
                        name: 'pets',
                        component: require('@/components/dashboard/admin/other/Pets')
                          .default,
                      },
                    ],
                  },
                  {
                    path: 'settings',
                    component: require('@/components/dashboard/admin/settings/SettingsWrapper')
                      .default,
                    children: [
                      {
                        path: '',
                        name: 'settings',
                        component: require('@/components/dashboard/admin/settings/Settings')
                          .default,
                      },
                    ],
                  },
                  {
                    path: 'activity',
                    component: require('@/components/dashboard/admin/activity/ActivityLogWrapper')
                      .default,
                    children: [
                      {
                        path: '',
                        name: 'activity',
                        component: require('@/components/dashboard/admin/activity/ActivityLogTable')
                          .default,
                      },
                    ],
                  },
                ],
              },
            ],
          ),
          ...applyRules(
            ['parent'],
            [
              {
                path: 'p',
                component: require('@/components/dashboard/parent/FamilyWrapper')
                  .default,
                children: [
                  {
                    path: 'profile',
                    name: 'profile-family',
                    component: require('@/components/dashboard/parent/FamilyProfile')
                      .default,
                    props: true,
                  },
                  {
                    path: 'sessions',
                    component: require('@/components/dashboard/admin/session/SessionWrapper')
                      .default,
                    children: [
                      {
                        path: 'archive',
                        name: 'sessions.archive.title',
                        component: require('@/components/dashboard/parent/Session/SessionArchiveTable')
                          .default,
                      },
                      /* { path: 'completed', name: 'sessions-completed', component: require('@/components/dashboard/admin/session/SessionsCompletedTable').default } */
                    ],
                  },
                ],
              },
            ],
          ),
          ...applyRules(
            ['babysitter'],
            [
              {
                path: 'b',
                component: require('@/components/dashboard/babysitter/BabysitterWrapper')
                  .default,
                children: [
                  {
                    path: 'profile',
                    name: 'profile-babysitter',
                    component: require('@/components/dashboard/babysitter/BabysitterProfile')
                      .default,
                    props: true,
                  },
                  {
                    path: 'documents',
                    name: 'documents',
                    component: require('@/components/dashboard/babysitter/Documents')
                      .default,
                  },
                  {
                    path: 'sessions',
                    component: require('@/components/dashboard/admin/session/SessionWrapper')
                      .default,
                    children: [
                      {
                        path: 'archive',
                        name: 'sessions.archive.title',
                        component: require('@/components/dashboard/babysitter/Session/SessionArchiveTable')
                          .default,
                      },
                      /* { path: 'completed', name: 'sessions-completed', component: require('@/components/dashboard/admin/session/SessionsCompletedTable').default } */
                    ],
                  },
                ],
              },
            ],
          ),
        ],
      },
    ],
  ),
  { path: '*', redirect: { name: 'index' } },
];

function applyRules(rules: any, routes: any) {
  for (let i in routes) {
    routes[i].meta = routes[i].meta || {}; // init routes meta if it doesnt exist

    if (!routes[i].meta.rules) {
      routes[i].meta.rules = []; // init meta rules array if it doesnt exist
    }

    routes[i].meta.rules.unshift(...rules); // prepend rules to rules array

    if (routes[i].children) {
      // recursively repeat the process on children array if exists
      routes[i].children = applyRules(rules, routes[i].children);
    }
  }

  return routes;
}
